const rooster = {
  threads: {
    borderLeft: '1px solid #cccccc',
    position: 'relative',
    width: '298px',
    height: '100%',
    float: 'left',
  },
  tabs: {
    position: 'relative',
    // width: '150px',
    width: '100%',
    borderBottom: '1px solid #ccc',
  },
  tab: {
    backgroundColor: 'white',
    color: 'black',
    border: '1px solid white',
  },
  swipableThreads: {
    position: 'relative',
    overflow: 'hidden',
  },
}

const tops = {
  threads: {
    borderLeft: '1px solid grey',
    position: 'relative',
    width: '300px',
    height: '100%',
    float: 'left',
    backgroundColor: 'white',
  },
  tabsContainer: {
    backgroundColor: 'transparent',
  },
  tabs: {
    position: 'relative',
    // width: '150px',
    width: '100%',
    borderBottom: '1px solid grey',
  },
  tab: {
    color: 'black',
    backgroundColor: 'white',
  },
  swipableThreads: {
    // top: '60px',
    position: 'relative',
    overflow: 'hidden',
    // borderTop: '1px solid grey'
  },
}

module.exports = process.env.REACT_APP_IS_TOPS ?
  tops :
  rooster



// WEBPACK FOOTER //
// ./src/components/Messages/styles/ConversationsContainer.js